/* Hand-written GraphQL documents for AccountExecutive (CONF-177).
   Mirrors catalogAuthorOps.js; regenerate/replace if codegen is re-run.

   The roster is one small list — a few dozen rows at the very most — so the
   list query takes no filter and pages once at limit: 1000 rather than
   threading nextToken through the hook. */

const FIELDS = 'id name email isTest createdAt createdBy updatedBy';

export const listAccountExecutives = /* GraphQL */ `
  query ListAccountExecutives($limit: Int, $nextToken: String) {
    listAccountExecutives(limit: $limit, nextToken: $nextToken) {
      items { ${FIELDS} }
      nextToken
    }
  }
`;

export const createAccountExecutive = /* GraphQL */ `
  mutation CreateAccountExecutive($input: CreateAccountExecutiveInput!) {
    createAccountExecutive(input: $input) { ${FIELDS} }
  }
`;

export const updateAccountExecutive = /* GraphQL */ `
  mutation UpdateAccountExecutive($input: UpdateAccountExecutiveInput!) {
    updateAccountExecutive(input: $input) { ${FIELDS} }
  }
`;

export const deleteAccountExecutive = /* GraphQL */ `
  mutation DeleteAccountExecutive($input: DeleteAccountExecutiveInput!) {
    deleteAccountExecutive(input: $input) { id }
  }
`;
